export const DELETE_COMMISSION_FORM = "deleteCommissionForm";
export const EDIT_COMMISSION_FORM = "editCommissionForm";
export const NEW_COMMISSION_FORM = "newCommissionForm";